export default "__VITE_ASSET__DHG8Ivg___"